import React from 'react'
import axios from 'axios'
import qs from 'qs'
import { CellsTitle, Cells, Cell, CellBody, CellFooter, Toast, Dialog } from 'react-weui'
import {Page} from '../../components'
import { browserHistory } from 'react-router'
import { updateSuccess, delSuccess } from '../../utils/connectApp'
import { isLZWKAPP } from '../../utils'
import config from '../../config'
import '../../css/page/ChannelEditPage.css'


class ChannelEditPage extends React.Component {
    constructor (props) {
        super(props)
        this.isHasHTML = false
        this.state = {
            channel: null,
            alertDialog: {
                channel: null,
                isShow: false,
                text: '',
            },
            isShowConfirmDialog: false,
            isShowNoEnterDialog: false,
        }
    }
    componentDidMount () {
        document.title = '编辑专栏'
        updateSuccess({
            type: 'channel'
        })
        this.fetchData()

        //风控
        // this.page.showFengKongTip()
    }
    fetchData () {
        axios.get(`/api/channel/${this.props.params.id}/edit_info`)
            .then(res => {
                const desc = res.data.data.channel.description
                this.isHasHTML = /Powered-by-XIUMI/.test(desc)
                this.setState({
                    channel: res.data.data.channel
                })
            })
    }
    onClickCloseChannelOk () {
        this.setState({ isPending: true, isShowConfirmDialog: false })
        axios.post(`/api/channel/${this.props.params.id}/edit`, qs.stringify({
            status: 'draft',
        }))
            .then(res => {
                this.setState({ isPending: false })
                if (res.data.code !== 0) {
                    return alert(res.data.msg)
                }
                this.setState({
                    alertDialog: { isShow: true, text: '下架成功' }
                })
            })
    }
    onClickAlertOk () {
        this.setState({ alertDialog: { isShow: false } })
        if (isLZWKAPP()) {
            delSuccess({
                type: 'channel'
            })
        } else {
            location.assign(`/liveroom/${this.state.channel.liveroom_id}`)
        }
    }
    onClickDesc () {
        if (this.isHasHTML) {
            this.setState({ isShowNoEnterDialog: true })
        } else {
            location.assign(`/channel/${this.props.params.id}/edit/desc`)
        }
    }
    render() {
        const channelId = this.props.params.id
        return (
            <Page parent={this}>
                <div className="wk-inner-page channel-edit-page">
                    <CellsTitle>编辑专栏</CellsTitle>
                    <Cells>
                        <CellLink link={`/channel/${channelId}/edit/title`} title='标题与副标题' />
                        <CellLink link={`/channel/${channelId}/edit/cover`} title='自定义封面图' />
                        <CellLink onClickFn={() => this.onClickDesc()} title='介绍内容' />
                        <CellLink link={`/channel/${channelId}/edit/pay`} title='付费选项' />
                        <CellLink link={`/channel/${channelId}/edit/priority`} title='专栏优先级' />
                        {/*<CellLink link={`/channel/${channelId}/edit/expected_lectures`} title='预计更新' />*/}
                        <CellLink onClickFn={e => this.setState({ isShowConfirmDialog: true })} title='下架' isHideAccess={true} />
                    </Cells>
                    <p className="intro">
                        电脑使用谷歌浏览器打开 {config.ADMIN_BASE_URL} 可以使用更强大的编辑功能。
                    </p>
                </div>
                <Toast icon="loading" show={this.state.isPending}></Toast>
                {/* 提示框 */}
                <Dialog type="ios" title='' buttons={[
                    { label: '确定', onClick: () => this.onClickAlertOk() }
                ]} show={this.state.alertDialog.isShow}>
                    {this.state.alertDialog.text}
                </Dialog>
                {/* 不能进入框 */}
                <Dialog type="ios" title='' buttons={[
                    { label: '确定', onClick: () => this.setState({ isShowNoEnterDialog: false }) }
                ]} show={this.state.isShowNoEnterDialog}>
                    此介绍含有富文本模版内容，请到讲师管理后台进行编辑（{config.ADMIN_BASE_URL}）
                </Dialog>
                {/* 下架确认框 */}
                <Dialog type="ios" title='' buttons={[
                    { label: '取消', type: 'default', onClick: () => this.setState({ isShowConfirmDialog: false }) },
                    { label: '确定', onClick: () => this.onClickCloseChannelOk() },
                ]} show={this.state.isShowConfirmDialog}>
                    专栏下架后，可到讲师管理后台（{config.ADMIN_BASE_URL}）重新上架、编辑和删除。确定下架吗？
                </Dialog>
            </Page>
        )
    }
}


function CellLink (props) {
    const access = props.isHideAccess ? { access: false } : { access: true }
    const onClickFn = props.link ? () => location.assign(props.link) : props.onClickFn
    return (
        <Cell onClick={onClickFn} {...access}>
            <CellBody>
                {props.title}
            </CellBody>
            <CellFooter>
                {props.desc || ''}
            </CellFooter>
        </Cell>
    )
}

export default ChannelEditPage

{/* <style>.desc-class img{max-width:100%!important; height:auto} .desc-class iframe{max-width:480px!important; max-height:320px!important;width:95vw;height:calc(95vw * 0.75)}</style><div class="desc-class" style="width=100%;max-width=480px;">i am desc</div> */}



// WEBPACK FOOTER //
// ./src/pages/ChannelEdit/ChannelEditPage.js